import { Dispatch, useState } from "react";
import { Filters } from "../../../models/Filters";
import { DescriptionFilter } from "../../filters/descriptionFilter";
import { StyledInvoiceListHeader } from "./invoiceListheader.styled";
import { InvoiceDateFilter } from "../../filters/invoiceDateFilter";
import { useInvoice } from "../../../stores/useInvoice";
import { PaymentDateFilter } from "../../filters/paymentDateFilter";
import { NameFilter } from "../../filters/nameFilter";
import { TypeFilter } from "../../filters/typeFilter";
import { QuarterFilter } from "../../filters/QuarterFilter";
import { Box } from "@mui/material";

type InvoiceFilterBarProps = {
  filters: Filters;
  setFilters: Dispatch<React.SetStateAction<Filters>>;
  availableQuarters: Record<string, string[]>;
  availableYears: string[];
  availableDescriptions: string[];
};

export const InvoiceFilterBar = ({
  filters,
  setFilters,
}: InvoiceFilterBarProps) => {
  const { invoices } = useInvoice();

  if (!invoices) return <></>;

  const handleFilterChange = (updatedFilter: Partial<Filters>) => {
    console.log(updatedFilter);
    setFilters((prev) => ({
      ...prev,
      ...updatedFilter,
    }));
  };

  return (
    <StyledInvoiceListHeader>
      <Box className="invoiceDate">
        <InvoiceDateFilter
          filters={filters}
          onChange={(val) => handleFilterChange(val)}
        />
      </Box>
      <Box className="paymentDate">
        <PaymentDateFilter
          filters={filters}
          onChange={(val) => handleFilterChange(val)}
        />
      </Box>
      <Box className="ref" />
      <Box className="name">
        <NameFilter
          filters={filters}
          onChange={(val) => handleFilterChange(val)}
        />
      </Box>
      <Box className="description">
        <DescriptionFilter
          filters={filters}
          onChange={(val) => handleFilterChange(val)}
        />
      </Box>
      <Box className="type">
        <TypeFilter
          filters={filters}
          onChange={(val) => handleFilterChange(val)}
        />
      </Box>
      <Box className="value"></Box>
      <Box className="value"></Box>
      <Box className="value"></Box>
      <Box className="quarter">
        <QuarterFilter
          filters={filters}
          onChange={(val) => handleFilterChange(val)}
        />
      </Box>
      <Box className="buttonWrapper"></Box>
    </StyledInvoiceListHeader>
  );
};
